import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

// Create a cache for pays data
const paysCache = {
  data: null,
  timestamp: null,
  maxAge: 5 * 60 * 1000, // 5 minutes
};

const client = createClient({
  projectId: 'yolwavex',
  dataset: 'production',
  apiVersion: '2021-08-31',
  token: "sktBJqtReb6CmOujwia1sPjHfwoZoQKZ1yKZJ1ndcGcLdBD6cvjx2RHqyHIpNQaNVDTxHXMZTUdAr7cnUPUTnWHvVFN4uimWWbcDPuI5plUMwTx6M20iP0NK3rq4S3joPkjrBjEqx4ZUJRwOZd2umjOe8Rt1aePhjPCF1brIDBX7Ti9Zk8Tf",
  useCdn: true,
  retries: 3,
  retryDelay: (attemptNumber) => Math.min(1000 * 2 ** attemptNumber, 10000),
  ignoreBrowserTokenWarning: true,
  perspective: 'published',
  stega: false,
});

// Add logging for client configuration
console.log('Sanity client configuration:', {
  projectId: 'yolwavex',
  dataset: 'production',
  apiVersion: '2021-08-31',
  useCdn: true,
  retries: 3,
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => {
  if (!source) {
    console.warn('urlFor called with null or undefined source');
    return null;
  }
  try {
    return builder.image(source);
  } catch (error) {
    console.error('Error generating image URL:', error);
    return null;
  }
};

// Enhanced fetch method with caching and better error handling
const originalFetch = client.fetch;
client.fetch = async (...args) => {
  const query = args[0];
  const params = args[1] || {};
  
  // Check if this is a pays query
  const isPaysQuery = query.includes('_type == "pays"');
  
  if (isPaysQuery) {
    // Check cache first
    if (paysCache.data && paysCache.timestamp) {
      const now = Date.now();
      if (now - paysCache.timestamp < paysCache.maxAge) {
        console.log('Returning pays data from cache');
        return paysCache.data;
      }
    }
  }

  console.log('Sanity fetch called with args:', { query, params });
  
  try {
    const result = await originalFetch.apply(client, args);
    console.log('Sanity fetch successful:', result);
    
    // Cache pays data if this was a pays query
    if (isPaysQuery) {
      paysCache.data = result;
      paysCache.timestamp = Date.now();
    }
    
    return result;
  } catch (error) {
    console.error('Sanity fetch failed:', error);
    
    // If we have cached pays data and this is a pays query, return it as fallback
    if (isPaysQuery && paysCache.data) {
      console.log('Returning cached pays data as fallback');
      return paysCache.data;
    }
    
    throw error;
  }
};

export default client;





